import { Component } from '@angular/core';
import {ConfirmDialogModule} from "primeng/confirmdialog";

@Component({
  selector: 'app-modal-confirmation',
  standalone: true,
  imports: [
    ConfirmDialogModule
  ],
  templateUrl: './modal-confirmation.component.html',
  styleUrl: './modal-confirmation.component.css'
})
export class ModalConfirmationComponent {

}
